export default class SpinnerSvc {
    private static spinner: any = null;

    public static set(spinner: any) {
        SpinnerSvc.spinner = spinner;
    }

    public static show(): void {
        SpinnerSvc.spinner.start();
    }

    public static hide(): void {
        setTimeout(() => SpinnerSvc.spinner.complete(), 30);
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/SpinnerSvc.ts